module.exports = __webpack_public_path__ + "img/woman01.ff55df64.jpg";